import Ajax from '../js/common/ajax';

export default {
  getConfigValue(keyFlag) {
    return Ajax.get('/common/config/get', {keyFlag});
  },
  updateConfigValue(params) {
    return Ajax.post('/common/config/update', params);
  }
}
